import ScrolableLayout from './ScrollableLayout.component';

export default ScrolableLayout;
